import { parseEnv } from '@nohara/react-core';
import z from 'zod';

export const env = parseEnv({
  API_ENDPOINT: z.string().url(),
  OAUTH_DOMAIN: z.string(),
  USER_POOL_ID: z.string(),
  USER_POOL_WEB_CLIENT_ID: z.string(),
  OIDC_CALLBACK_PATH: z.string().default('/oauth/callback'),
  SIGN_OUT_PATH: z.string().default('/login'),
});
